<!--
 * @Autor: lu jun jie
 * @Date: 2020-11-18
 * @Description:
-->
<template>
    <div id="appTop">
        <!--底部 -->
        <!-- new footer star -->
        <div class="footer">
            <p>游戏版权归原作者享有，如无意之中侵犯了您的版权，请按照《版权保护投诉指引》来信告知，本站将应您的要求删除</p>
            <p class="firstLine">
                健康游戏忠告 | 抵制不良游戏 | 拒绝盗版游戏 | 注意自我保护 | 谨防受骗上当
                | 适度游戏益脑 | 沉迷游戏伤身 | 合理安排时间 | 享受健康生活
            </p>
            <p>Copyright © 2018 广州天蝎互动网络科技有限公司 版权所有</p>
            <p>
                <a href="http://beian.miit.gov.cn/" target="_blank">粤ICP备18124867号-1</a>
                <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44010602008126" target="_blank">粤公网安备 44010602008126号</a>
                <a href="../../../../static/img/www.png" rel="nofollow" target="_blank">粤网文〔2018〕10203-3586号</a>
                <a href="../../../../static/img/auth.png" rel="nofollow" target="_blank">增值电信业务许可证：粤B2-20200545</a>
                <a href="http://sq.ccm.gov.cn/ccnt/sczr/service/business/emark/toDetail/c4247b783ac2496ab5549de8426cc2be">
                    <img border="1" height="35" src="../../../../Public/Media/images/ww.png" style="position: absolute; right: 600px" widht="35" />
                </a>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "appTop",
};
</script>



// WEBPACK FOOTER //
// src/components/common/footer/index.vue